import { Injectable } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';

import {
    HisFileUploadService,
    HisUploadConfiguration,
    UploadFieldConfigResponse,
    HisGenericValueService,
    GenericValue
} from 'hisng';

@Injectable()
export class PublicationDocumentMetadataService {
    confKey = 'fs.res.publication.publication.edit';

    constructor( public fileUploadService: HisFileUploadService, public genericValueService: HisGenericValueService ) { }

    getConfKey() {
        return this.confKey;
    }

    getPublicationDocumentCategories( selectedCategoryId?: number ): Observable<GenericValue[]> {
        return this.genericValueService.getValueTypes('documentMetadataCategoryValue')
            .pipe(switchMap(categories => this.fileUploadService.getUploadFieldConfig( this.confKey, null, null )
                .pipe(map((config: UploadFieldConfigResponse) => {
                    const documentMetadataCategoryIds = new HisUploadConfiguration( config ).getDocumentMetadataCategoryIds();
                    if (selectedCategoryId) {
                        documentMetadataCategoryIds.push(selectedCategoryId);
                    }
                    return categories.filter(c => documentMetadataCategoryIds.includes(c.id));
                }))
            ));
    }
}
